export function getFirstSelectedFile($event: Event) {
  return ($event.target as HTMLInputElement)!.files![0];
}
